import { StyledWrapper } from "./Wrapper.style";

const Wrapper = ({ children, id }) => {
    return (
        <StyledWrapper id={id}>{children}</StyledWrapper>
    )
}

export default Wrapper;